import "./Tours.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import TourFilterBar from "./sections/TourFilterBar";
import ToursGrid from "./sections/ToursGrid";
import ExploreMoreCta from "./sections/ExploreMoreCta";
import ToursResults from "./sections/ToursResults";
import Footer from "@/reusable_sections/Footer";
export default function ToursPage() {
  return <div>
      <Header />
      <Hero />
      <TourFilterBar />
      <ToursResults />
      <ToursGrid />
      <ExploreMoreCta />
      <Footer />
    </div>;
}